import { NgModule } from '@angular/core';

import { SafePipe } from '../_pipe/safe.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BlockUIModule } from 'ng-block-ui';
import { TranslateModule } from '@ngx-translate/core';
import { ApiService } from './api.service';
import { SessionService } from './session.service';
import { ImgPipe } from '../_pipe/img.pipe';
import { EncodeUrlPipe } from '../_pipe/encode-url.pipe copy';
import { DataTablesModule } from 'angular-datatables';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MomentModule } from 'ngx-moment';
import { ColorChromeModule } from 'ngx-color/chrome';
import { ProductService } from './product.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ValutaPipe } from '../_pipe/valuta.pipe';

@NgModule({
	declarations: [SafePipe, ValutaPipe, ImgPipe, EncodeUrlPipe],
	imports: [
		CommonModule,
		FormsModule,
		NgxDatatableModule,
		NgbModule,
		TranslateModule.forChild(),
		BlockUIModule,
		DataTablesModule.forRoot(),
		NgMultiSelectDropDownModule.forRoot(),
		MomentModule,
		ColorChromeModule,
		DragDropModule,
	],
	exports: [
		SafePipe,
		ValutaPipe,
		ImgPipe,
		EncodeUrlPipe,
		CommonModule,
		FormsModule,
		NgxDatatableModule,
		NgbModule,
		BlockUIModule,
		TranslateModule,
		DataTablesModule,
		NgMultiSelectDropDownModule,
		MomentModule,
		ColorChromeModule,
		DragDropModule,
	],
	providers: [ApiService, SessionService, ProductService],
	entryComponents: [],
})
export class SharedModule {}
